export default __webpack_public_path__ + "static/suzie-a55d6528cbeb47beb80c19a142ea160f.png";